import { Android, Apple } from '@doist/icons/brand';
import { Box, Text } from '@doist/marketist';
import cn from 'clsx';
import { googlePlayAndAppStoreReviewCount } from 'config/constants';
import { type TFunction } from 'i18next';
import css from './reviews-counter.module.css';
export type ReviewsCounterProps = {
  t: TFunction;
  className?: string;
};
export function ReviewsCounter({
  t,
  className
}: ReviewsCounterProps) {
  const counter = googlePlayAndAppStoreReviewCount / 1000;
  return <Box className={cn(css.reviewsCounter, className)} data-sentry-element="Box" data-sentry-component="ReviewsCounter" data-sentry-source-file="reviews-counter.tsx">
            <Text size="minor-base" weight="semibold" data-sentry-element="Text" data-sentry-source-file="reviews-counter.tsx">
                {t('reviewsCounter.text', {
        counter
      })}
            </Text>
            <Box className={cn(css.platformIcons, 'mis-8')} data-sentry-element="Box" data-sentry-source-file="reviews-counter.tsx">
                <Apple data-sentry-element="Apple" data-sentry-source-file="reviews-counter.tsx" />
                <Android data-sentry-element="Android" data-sentry-source-file="reviews-counter.tsx" />
            </Box>
        </Box>;
}